var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___SkkzN0",
  "V8": "GuildFolderItem.module__relative___SkkzN0",
  "o6": "GuildFolderItem.module__collapsedFolder___SkkzN0",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___SkkzN0",
  "sD": "GuildFolderItem.module__miniGuildIcon___SkkzN0",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___SkkzN0",
  "mw": "GuildFolderItem.module__folderBadge___SkkzN0",
  "M8": "GuildFolderItem.module__folderBadgeActive___SkkzN0",
  "k9": "GuildFolderItem.module__expandedFolderBackground___SkkzN0",
  "MJ": "GuildFolderItem.module__folderHeader___SkkzN0",
  "mK": "GuildFolderItem.module__folderHeaderButton___SkkzN0",
  "Eh": "GuildFolderItem.module__folderIcon___SkkzN0",
  "QD": "GuildFolderItem.module__expandedGuilds___SkkzN0",
  "h5": "GuildFolderItem.module__folderTooltipContainer___SkkzN0",
  "bO": "GuildFolderItem.module__folderTooltipName___SkkzN0",
  "Il": "GuildFolderItem.module__dropIndicatorTop___SkkzN0",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___SkkzN0",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___SkkzN0",
};

module.exports = exports;
